import { render, staticRenderFns } from "./MatchedFilesDashboard.vue?vue&type=template&id=00562402"
import script from "./MatchedFilesDashboard.vue?vue&type=script&lang=ts"
export * from "./MatchedFilesDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports